/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslation } from '@axo/shared/i18n';
import { Button } from '@axo/ui-core/components/Button';
import { Grid } from '@axo/ui-core/components/layout/item';
import { Modal } from '@axo/ui-core/components/Modal';
import { Text } from '@axo/ui-core/components/typography';
import { useFormContext } from 'react-hook-form';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';
import { useMarketingConsent } from '../../../../../../hooks/useMarketingConsent';
import type { Step7Data } from '../../../FormData.dk.types';
import { ConsentSection } from '../../../Main/ConsentSection';
import styles from './ConsentFormGroup.module.scss';

type ConsentFormGroupProps = {
  isModalOpen: boolean;
  onClick: () => void;
  onCloseModal: () => void;
};

export const ConsentFormGroup = ({
  isModalOpen,
  onClick,
  onCloseModal,
}: ConsentFormGroupProps) => {
  const { t } = useTranslation();

  const { setValue } = useFormContext();
  const { axoFormData } = useAxoFormContext<Step7Data>();

  const { showMarketingConsent = true } = useMarketingConsent({
    marketingConsent: axoFormData['Ignore/MarketingConsent'],
    shouldShowMarketingConsent: axoFormData['Ignore/ShowMarketingConsent'],
  });

  const handleAcceptConsent = () => {
    setValue('LoanApplication/CreditStatusConsent', true, {
      shouldTouch: true,
      shouldDirty: true,
    });
    onClick();
  };

  const handleRejectConsent = () => {
    setValue('Frontend/CreditStatusConsentRejected', true);
    onClick();
  };

  return (
    <>
      <ConsentSection
        showCreditConsent
        showMarketingConsent={showMarketingConsent}
      />

      <Modal
        open={isModalOpen}
        onClose={onCloseModal}
        className={styles.consent}
      >
        <Modal.Header feedbackState="warn">
          <Text size="xl">
            <b>{t('KreditConsent.request_info')}</b>
          </Text>
          <Text>{t('KreditConsent.request')}</Text>
        </Modal.Header>

        <Modal.Actions className={styles.consentActions}>
          <Grid columns={{ s: 1, m: 2, l: 2 }}>
            <Button
              variant="tertiary"
              onClick={handleRejectConsent}
              data-testid="reject-credit-consent-button"
            >
              {t('KreditConsent.reject')}
            </Button>
            <Button
              className={styles.accept}
              onClick={handleAcceptConsent}
              data-testid="accept-credit-consent-button"
            >
              {t('KreditConsent.accept')}
            </Button>
          </Grid>
        </Modal.Actions>
      </Modal>
    </>
  );
};
